export const home = {
myReports: {
title: "Tus avisos",
},
meta: {
untitledJob: "Orden de trabajo sin título",
noAssetLinked: "Sin activo vinculado",
unassigned: "Sin asignar",
emDash: "—",
},
aggregation: {
scheduledInspectionFallback: "Inspección programada",
jobOverdueSubtitle: "{{asset}} · Vencía el {{date}}",
jobOverdueNoDate: "{{asset}} · Vencido",
jobOverdueUnassigned: "Orden de trabajo vencida",
inspectionOverdueSubtitle: "{{asset}} · Vencía el {{date}}",
requestOverdueSubtitle: "{{asset}} · Vencía el {{date}}",
jobDueTodaySubtitle: "{{asset}} · Vence hoy",
inspectionDueTodaySubtitle: "{{asset}} · Vence hoy",
inspectionScheduledSubtitle: "{{asset}} · Programada para el {{date}}",
jobInProgressSubtitle: "{{asset}} · En curso",
followOnApprovalSubtitle: "{{asset}} · Aprobación de seguimiento",
completionReviewSubtitle: "{{asset}} · Revisión de finalización",
scheduledBadge: "Programado",
inProgressBadge: "En curso",
approvalBadge: "Aprobación",
requestSubtitle: "{{asset}} · Seguimiento",
followUpQueuePending: "Nuevas",
followUpQueueAwaitingCustomer: "Esperando al cliente",
followUpQueueApproved: "Aprobado",
followUpQueueScheduled: "Programado",
followUpQueueConverted: "Trabajo vinculado",
followUpQueueRejected: "Rechazado",
certificateActionsTitle: "Certificados por vencer",
certificateActionsEmpty: "No hay certificados por vencer",
certificatePendingValidation: "Pendiente de validación",
certificateRejected: "Rechazado",
certificateExpired: "Caducado",
certificateExpiringSoon: "Caduca pronto",
},
greeting: {
morning: "Buenos días",
afternoon: "Buenas tardes",
evening: "Buenas noches",
withName: "{{greet}}, {{name}}",
},
screen: {
title: "Inicio",
loadingCommandCenter: "Cargando tu inicio…",
},
summaryStrip: {
assets: "Activos",
openJobs: "Trabajos abiertos",
dueToday: "Para hoy",
requests: "Solicitudes",
},
commandQuickActions: {
scanQr: "Escanear QR",
},
commandEmpty: {
dueToday: "Nada previsto para hoy.",
needsAttention: "Nada requiere tu atención ahora mismo.",
requests: "Aún no hay solicitudes. Las solicitudes de activos compartidos aparecerán aquí.",
recentActivity: "Sin actividad reciente.",
},
commandSectionTitles: {
overdue: "Atrasado",
dueToday: "Para hoy",
requests: "Solicitudes",
recentActivity: "Actividad reciente",
},
commandCenter: {
statusBar: {
actionRequired: "Requiere acción",
needsAttention: "Necesita atención",
allSystemsNormal: "Todo en orden",
synced: "Sincronizado {{label}}",
},
aiBriefing: {
label: "Resumen operativo",
readMore: "Leer resumen →",
},
attentionQueue: {
title: "Cola de atención",
empty: "Bandeja vacía. Nada te reclama ahora mismo.",
showMore: "{{count}} más →",
snooze: "Posponer",
kind: {
request: "Solicitudes",
inspection: "Inspecciones",
job: "Trabajos",
document: "Documentos",
activity: "Actividad",
},
},
counters: {
dueInspections: "Inspecciones pendientes",
openRequests: "Solicitudes abiertas",
openJobs: "Trabajos abiertos",
workQueue: "Cola de trabajo",
},
recentActivity: {
title: "Actividad reciente",
defaultEmpty: "Todavía no hay actividad hoy.",
events_one: "{{count}} evento",
events_many: "{{count}} eventos",
events_other: "{{count}} eventos",
},
},
empty: {
firstAssetTitle: "Crea tu primer activo",
firstAssetSubtitle: "Añade un activo para empezar inspecciones y gestionar el trabajo.",
noAssetsInScopeTitle: "No hay activos en {{scope}}",
noAssetsInScopeSubtitle: "Cambia el filtro de ámbito arriba o añade activos a este equipo.",
noAssetsInScopeSubtitleWeb: "Cambia el ámbito o borra la búsqueda — los activos que coincidan aparecerán aquí.",
noAssetsInScopeShortWeb: "Cambia el ámbito o añade activos a este equipo.",
addAsset: "Añadir activo",
},
planNudge: {
asset_cap_limited: "Queda un activo en tu plan ({{limit}} incluidos). {{plan}} incluye {{nextLimit}}.",
asset_cap: "Te queda un activo en tu plan ({{limit}} incluidos). {{plan}} no tiene límite.",
same_contact: "Has enviado {{count}} trabajos a {{name}} este mes. Con {{plan}} los ve y actualiza por su cuenta.",
addresses: "Tus activos están en {{count}} direcciones. Los sitios, con {{plan}}, agrupan el trabajo por lugar.",
inspections: "{{count}} inspecciones en una semana es mucho para una sola persona. Los equipos, con {{plan}}, reparten la carga.",
seePlans: "Ver {{plan}}",
dismiss: "Ahora no",
},
teamSetup: {
title: "Configura tu equipo",
dismiss: "Ocultar la configuración del equipo",
steps: {
invite: "Invitar a un compañero",
site: "Añadir un sitio",
requests: "Permitir que otros soliciten trabajo (compartir un activo)",
},
},
firstRun: {
progress: "{{completed}} de {{total}} completados",
gettingStartedDefault: "Primeros pasos",
dismissDefault: "Ocultar primeros pasos",
trySampleDefault: "Pruebe una muestra",
removeSampleDefault: "Eliminar ejemplo",
title: "Primeros pasos",
subtitle: "Toca un paso. Cada uno te muestra exactamente dónde tocar.",
trySample: "Probar ejemplo",
removeSample: "Eliminar ejemplo",
createAsset: "Crear activo",
startInspection: "Iniciar inspección",
dismiss: "Ahora no",
whatIsThis: "¿Qué es esto?",
whatIsThisBody: "AssetWRX reúne tus activos, inspecciones y trabajos en un solo lugar, para que siempre sepas qué hacer a continuación.",
busy: "Preparando…",
error: "No se pudo preparar el ejemplo. Aún puedes crear un activo manualmente.",
suggested: "Sugerido",
steps: {
  document: "Añade un certificado",
asset: "Añade tu primer activo",
request: "Comparte un activo con alguien",
inspection: "Programa una inspección",
job: "Crea un trabajo",
contacts: "Invita a un compañero",
contactsNoTeams: "Añade un contacto",
},
coachmark: {
title: "Empieza aquí",
body: "Toca cualquier paso para empezar. Puedes hacerlos en cualquier orden.",
dismiss: "Entendido",
},
},
web: {
commandOverline: "Buscar y crear",
commandHint: "Busca en el espacio de trabajo, define el ámbito o añade activos, trabajos e inspecciones.",
searchPlaceholder: "Buscar activos, trabajos, inspecciones, informes…",
overviewTitle: "Resumen",
overviewHint: "Accesos directos y contadores en vivo para tu ámbito. Toca un KPI para la lista completa.",
overviewSnapshotLabel: "Instantánea",
overviewSnapshotHintWeb: "Activos · Inspecciones · Trabajos — toca una tarjeta para abrir esa lista.",
suggestedActionsTitle: "Acciones sugeridas",
suggestedActionsHint: "Prioridades por reglas en este ámbito. Abre una tarjeta para ir a la lista o al trabajo.",
workQueueTitle: "Cola de trabajo",
workQueueHint: "Trabajos e inspecciones priorizados. Selecciona una fila para ver detalles.",
activeWorkQueueTitle: "Cola de trabajo activa",
workQueueSectionMeta: "Trabajos, inspecciones y programaciones — filtra o abre una fila.",
queueEmptyNoItems: "No hay trabajos ni inspecciones accionables en este ámbito.",
queueEmptyNoFilter: "Ningún elemento coincide con este filtro.",
automationHint: "Conversiones, sugerencias de trabajo desde inspecciones completadas e invitaciones de equipo.",
detailJobTitle: "Detalles del trabajo",
detailOverviewTitle: "Resumen",
detailEmpty: "Aún no hay trabajo en este ámbito. Usa Creación rápida en la cabecera para empezar.",
detailCommandSummary: "Resumen del centro de mando",
detailIdleLead: "Selecciona una fila en la cola para detalles, acciones principales y actividad reciente.",
detailStatOpenJobs: "Trabajos abiertos",
detailStatOverdue: "Atrasados",
detailStatUnassigned: "Sin asignar",
detailNextUp: "Siguiente en la cola",
viewAssetDetailsA11y: "Ver todos los detalles del activo",
scheduleWorkA11y: "Programar trabajo",
moreActions: "Más acciones",
moreActionsA11y: "Más acciones",
copilotSectionTitle: "Asistente de operaciones",
copilotEmptyTitle: "Sin señales prioritarias",
copilotEmptyBody: "Aún no hay nada urgente en este ámbito. Ajusta filtros, añade trabajo o revisa Analítica y Trabajo.",
copilotDockHint: "Prioridades basadas en reglas para tu ámbito. Cada tarjeta enlaza a la lista o trabajo adecuado.",
},
snapshot: {
inspectionsSublabelDrafts: "Borradores y en pausa",
inspectionsSublabelScheduled_one: "Borradores y en pausa · {{count}} programada",
inspectionsSublabelScheduled_other: "Borradores y en pausa · {{count}} programadas",
jobsSublabelNotClosed: "No cerrados",
jobsSublabelOverdue_one: "No cerrados · {{count}} atrasado",
jobsSublabelOverdue_other: "No cerrados · {{count}} atrasados",
inThisScope: "En este ámbito",
findingsSublabel: "Informes completados con ítems no superados",
unassignedSublabel: "Trabajos abiertos sin responsable",
inspectionsSublabelScheduled_many: "Borradores y en pausa · {{count}} programadas",
jobsSublabelOverdue_many: "No cerrados · {{count}} atrasados",
},
queueFilter: {
all: "Todo el trabajo",
overdue: "Atrasado",
inProgress: "En curso",
dueSoon: "Próximo a vencer",
},
queue: {
labels: {
asset: "Activo",
due: "Vence",
status: "Estado",
assignee: "Asignado a",
scheduled: "Programado",
nextStep: "Siguiente paso",
started: "Iniciado",
priority: "Prioridad",
created: "Creado",
location: "Ubicación",
dueDate: "Fecha de vencimiento",
},
status: {
overdue: "Atrasado",
due: "Vence",
paused: "En pausa",
inProgress: "En curso",
awaitingSchedule: "Esperando programación",
unassigned: "Sin asignar",
},
subtitle: {
overdue: "{{asset}} • Atrasado",
activeWork: "{{asset}} • Trabajo activo",
dueThisWeek: "{{asset}} • Vence esta semana",
scheduledInspection: "{{asset}} • Inspección programada",
needsSchedule: "{{asset}} • Necesita programación",
unassigned: "{{asset}} • Sin asignar",
resumeChecklist: "{{asset}} • Reanudar lista",
},
title: {
inspectionOverdue: "Inspección atrasada",
inspectionDue: "Inspección pendiente",
inspectionInProgress: "Inspección en curso",
},
typeJob: "Trabajo",
typeInspection: "Inspección",
primaryOpenJob: "Abrir orden de trabajo",
primaryResumeInspection: "Reanudar inspección",
primaryStartInspection: "Iniciar inspección",
openWork: "Abrir trabajo",
nextStepSetSchedule: "Establecer fecha y hora",
nextStepAssign: "Asignar equipo o contratista",
},
sections: {
quickActions: "Acciones rápidas",
quickActionsCardTitle: "Accesos directos",
quickActionsHintSetup: "Escanear y crear trabajo.",
quickActionsHintFull: "Escanear, crear trabajo e ir a lo urgente.",
snapshot: "Instantánea",
snapshotHint: "Activos · Inspecciones · Trabajos — toca para abrir",
myWork: "Mi trabajo",
myWorkHint: "Continúa, asigna o termina lo que te corresponde.",
needsAttention: "Requiere atención",
needsAttentionHint: "Agrupado por tipo — mismos elementos, más fácil de leer.",
workflowSuggestions: "Sugerencias de flujo",
workflowHint: "Resultados del flujo de inspección listos para el siguiente paso.",
viewAll: "Ver todo",
attentionQueue: "Atención",
attentionQueueCollapsedHint: "Toca para ampliar el desglose completo de prioridades",
attentionQueueShowLess: "Mostrar menos",
attentionEmpty: "Sin trabajo urgente en este alcance.",
moreToolsTitle: "Más herramientas",
moreToolsBody: "Analítica, actividad completa y el banco de trabajo.",
contractorInvitesBanner_one: "Tiene una invitación para presupuestar o realizar un trabajo — toque para responder",
contractorInvitesBanner_other: "Tiene {{count}} invitaciones para presupuestar o realizar trabajos — toque para responder",
workspaceDeeperTitle: "Más señales",
workspaceDeeperSummary: "Planificación, trabajo activo y actividad.",
commandShortcutsTitle: "Crear o abrir",
commandShortcutsSummary: "Añada trabajo o abra la siguiente cola.",
jumpToTitle: "Abrir",
jumpToSummary: "Registros e informes.",
contractorInvitesBanner_many: "Tiene {{count}} invitaciones para presupuestar o realizar trabajos — toque para responder",
},
welcome: {
subtitleDefault: "Trabajo de hoy",
subtitleRecipient: "Los informes y trabajos compartidos necesitan tu respuesta",
},
kpiStrip: {
pendingReviews: "Revisiones",
pendingReviewsSub: "Esperando tu respuesta",
complianceSub: "Documentos e inspecciones vencidas",
},
attentionGroups: {
approvals: "Aprobaciones y revisiones",
people: "Personas y respuestas",
time: "Tiempo y riesgo",
},
tasks: {
jobInvitations: {
title: "Invitaciones de trabajo",
sub: "Aceptar o rechazar",
},
yourTurn: {
title: "Te toca",
sub: "Aceptar o rechazar trabajo",
},
reworkRequested: {
title: "Retrabajo solicitado",
sub: "Reasignar trabajo",
},
workInProgress: {
title: "Trabajo en curso",
sub: "Completar o publicar actualización",
},
scheduleProposed: {
title: "Horario propuesto",
sub: "Establecer fecha y hora",
},
approvedRepairs: {
title: "Reparaciones aprobadas",
sub: "Convertir en trabajos",
},
unassignedWork: {
title: "Trabajo sin asignar",
sub: "Asignar equipo o contratista",
},
draftInspection: {
title: "Inspección borrador",
sub: "Reanudar",
},
inspectionDue: {
title: "Inspección pendiente",
sub: "Atrasada o 60+ días",
},
criticalIssues: {
title: "Problemas críticos",
sub: "Salud pobre",
},
followOnProposed: {
title: "Seguimiento propuesto",
sub: "Aprobar o rechazar antes de asignar",
},
completionSubmitted: {
title: "Finalización enviada",
sub: "Aprobar o pedir retrabajo",
},
reportAwaitingReview: {
title: "Informe en revisión",
sub: "Aprobar o rechazar reparaciones",
},
awaitingRecipient: {
title: "Esperando al destinatario",
sub: "Revisar",
},
awaitingRecipientResponse: {
title: "Esperando respuesta",
sub: "Seguimiento de revisiones",
},
overdueJobs: {
title: "Trabajos atrasados",
sub: "Resolver trabajos estancados",
},
},
pinned: {
scanQr: "Escanear QR",
inspect: "Inspeccionar",
createJob: "Crear trabajo",
},
contextual: {
reviewReport: "Revisar informe",
respondToAssignment: "Responder a la asignación",
approveFollowOn: "Aprobar seguimiento",
approveCompletion: "Aprobar finalización",
continueJob: "Continuar trabajo",
resumeInspection: "Reanudar inspección",
addAsset: "Añadir activo",
},
webQuickCreate: {
createInspection: "Crear inspección",
createTemplate: "Crear lista de control",
createJob: "Crear orden de trabajo",
scheduleWork: "Programar trabajo",
shortAsset: "Activo",
shortRequest: "Solicitud",
shortInspection: "Inspeccionar",
shortJob: "Trabajo",
},
kpi: {
assets: "Activos",
inspections: "Inspecciones",
jobs: "Trabajos",
unassigned: "Sin asignar",
findings: "Hallazgos",
},
automation: {
approvedRepairsTitle: "Reparaciones aprobadas",
suggestedJobsTitle: "Trabajos sugeridos desde inspección",
teamInvitesTitle: "Invitaciones de equipo",
},
urgency: {
critical: "Crítico",
medium: "Medio",
low: "Bajo",
},
priorityDot: {
a11y: "Prioridad {{level}}",
level: {
p1: "crítico",
p2: "medio",
p3: "bajo",
none: "ninguno",
},
},
workLanes: {
kindLabel: {
request: "Solicitudes",
inspection: "Inspecciones",
job: "Trabajos",
},
kindLabelLower: {
request: "solicitudes",
inspection: "inspecciones",
job: "órdenes de trabajo",
},
empty: "Nada te necesita aquí.",
viewAll: "Ver todo: {{count}} {{kind}} →",
},
assetGroups: {
overdueBadge_one: "{{count}} vencida",
overdueBadge_many: "{{count}} vencidas",
overdueBadge_other: "{{count}} vencidas",
needsYouBadge: "{{count}} para usted",
openAssetMore: "Abrir activo · {{count}} más →",
openAsset: "Abrir activo →",
moreAssets_one: "{{count}} activo más con trabajo abierto",
moreAssets_other: "{{count}} activos más con trabajo abierto",
moreAssets_many: "{{count}} activos más con trabajo abierto",
},
sharedAssets: {
invitesA11y_one: "{{count}} invitación a un activo: aceptar o rechazar",
invitesA11y_other: "{{count}} invitaciones a activos: aceptar o rechazar",
invitesTitle_one: "Se compartió un activo con usted",
invitesTitle_other: "Se compartieron {{count}} activos con usted",
tapToAcceptOrDecline: "Toque para aceptar o rechazar",
activeA11y: "{{name}} — compartido contigo. Ábrelo para informar de un problema o ver su trabajo.",
activeSub: "Compartido contigo · Informar un problema o ver su trabajo",
invitesA11y_many: "{{count}} invitaciones a activos: aceptar o rechazar",
invitesTitle_many: "Se compartieron {{count}} activos con usted",
},
sectionCard: {
otherGroup: "Otro",
emptyDefault: "Nada aquí todavía",
},
commandCentre: {
  showMeHow: "Muéstrame cómo",
calendar: "Calendario",
stateLabel: {
actionNeeded: "Acción necesaria",
watch: "Para vigilar",
active: "Activa",
clear: "Sin incidencias",
},
eyebrow: {
needsYou: "Requiere su atención",
now: "Ahora",
decision: "Decisión",
},
onYourPlate: "Pendiente para ti",
watchlist: "Para vigilar",
upNext: "A continuación",
portfolioMovement: "Qué ha cambiado",
workspaceSummary: "Resumen del espacio de trabajo",
toMonitor: "{{count}} por revisar",
seeAll: "Ver todos",
seeAllA11y: "Ver todo ({{count}})",
assetRowA11y: "{{name}}. {{state}}. {{reason}}",
signalLabels: {
needsYou: "Requiere su atención",
atRisk: "En riesgo",
inMotion: "Activos",
dueSoon: "Vence pronto",
},
viewDetails: "Ver detalles",
moreOnAsset_one: "{{count}} más en {{name}} necesita la misma decisión",
moreOnAsset_other: "{{count}} más en {{name}} necesitan la misma decisión",
moreOnAssetA11y_one: "{{count}} más en {{name}} necesita la misma decisión. Abrir en Trabajo",
moreOnAssetA11y_other: "{{count}} más en {{name}} necesitan la misma decisión. Abrir en Trabajo",
signalRowA11y: "{{action}}: {{name}}. {{reason}}",
moreOnAsset_many: "{{count}} más en {{name}} necesitan la misma decisión",
moreOnAssetA11y_many: "{{count}} más en {{name}} necesitan la misma decisión. Abrir en Trabajo",
},
decisionModel: {
action: {
confirm: "Confirmar",
reply: "Responder",
review: "Revisar",
resolve: "Resolver",
createWork: "Crear trabajo",
resubmit: "Volver a enviar",
inviteMore: "Invitar más",
respond: "Responder",
open: "Abrir",
quote: "Enviar presupuesto",
triage: "Decidir",
resume: "Reanudar",
start: "Iniciar",
continueJob: "Continuar",
inspect: "Inspeccionar",
},
reason: {
overdue: "El trabajo atrasado necesita atención",
blocked: "El trabajo está bloqueado y necesita una decisión.",
doneConfirmWithName: "{{name}} marcó esto como hecho: confirme la solución",
doneConfirm: "El trabajo está hecho: confirme la solución",
visitConfirmWithName: "{{name}} planificó una visita: confirme que alguien puede estar allí o solicite una hora diferente",
visitConfirm: "Se planea una visita: confirme que alguien puede estar allí o solicite un horario diferente.",
needMoreInfo: "El equipo necesita más información tuya.",
waitingYourReview: "Pendiente de su revisión",
waitingYourReviewWithName: "{{name}} está esperando tu revisión",
reviewWaiting: "Una revisión o aprobación está esperando",
approvedNoWorkYet: "Aprobado: el trabajo aún no se ha creado",
reworkSentBackWithName: "Enviado de nuevo a {{name}} para que lo reelaboren, esperando que lo completen nuevamente.",
reworkSentBack: "Devuelto para reelaboración, esperando a que se complete nuevamente",
reworkOwnerRedo: "Devuelto para reelaboración: rehaga el trabajo y complételo nuevamente",
quotesDeclined: "Todos los invitados declinaron presentar presupuesto: invite a más contratistas",
waitingRequesterConfirm: "Esperando a que el solicitante confirme la solución",
acceptOrDeclineYou: "Asignado a usted: acepte o rechace antes de que comience el trabajo",
waitingAcceptWithName: "Esperando a que {{name}} acepte o rechace",
waitingAccept: "Esperando a que el responsable acepte o rechace",
waitingTriageWithName: "{{name}} está esperando una decisión",
waitingTriage: "Un solicitante está esperando una decisión",
workspaceUnavailable: "No pudimos cargar tu espacio de trabajo. Toca para intentarlo de nuevo.",
dueToday: "Vence hoy",
invitedToQuote: "Invitado a presentar presupuesto: responda con un precio o rechace",
pausedWithReason: "En pausa: {{reason}}. Reanudar cuando puedas",
pausedResume: "En pausa: reanudar cuando puedas",
onThisJob: "Usted está en esta orden de trabajo; complétela cuando el trabajo esté terminado.",
assignedStartOnSite: "Asignado a usted: comience cuando esté en el sitio",
scheduledApproaching: "Se acerca el trabajo programado",
pausedWithReasonOnly: "En pausa — {{reason}}",
paused: "Pausada",
inProgress: "El trabajo está en progreso",
fallback: "Se requiere atención operativa",
},
assetReason: {
actionRequired: "Se requiere acción",
criticalRisk: "Riesgo crítico del activo",
elevatedRisk: "Riesgo de activos elevado",
operationalConcern: "Preocupación operativa",
activeOrScheduled: "El trabajo está activo o programado.",
noException: "Nada requiere atención",
},
assetWatchSignal: {
criticalMonitor: "El riesgo crítico del activo requiere seguimiento",
elevatedMonitor: "El elevado riesgo de activos requiere monitoreo",
conditionNeedsAction: "El estado necesita atención",
},
brief: {
itemsNeed_one: "{{count}} elemento necesita atención.",
itemsNeed_other: "{{count}} elementos necesitan atención.",
conditionsWatchClause_one: " {{count}} más para vigilar.",
conditionsWatchClause_other: " {{count}} más para vigilar.",
nothingNeedsYou: "Nada te necesita en este momento.",
watchlist_one: "Nada requiere su atención en este momento. {{count}} cosa para vigilar.{{motion}}",
watchlist_other: "Nada requiere su atención en este momento. {{count}} cosas para vigilar.{{motion}}",
inMotionOnly_one: "Nada requiere su atención en este momento. {{count}} elemento está planificado o en curso.",
inMotionOnly_other: "Nada requiere su atención en este momento. {{count}} elementos están planificados o en curso.",
invitationsOnly_one: "{{count}} invitación para presupuestar o realizar un trabajo espera su respuesta.",
invitationsOnly_other: "{{count}} invitaciones para presupuestar o realizar trabajos esperan su respuesta.",
invitationsOnly_many: "{{count}} invitaciones para presupuestar o realizar trabajos esperan su respuesta.",
inMotionClause_one: " {{count}} elemento está planificado o en curso.",
inMotionClause_other: " {{count}} elementos están planificados o en curso.",
itemsNeed_many: "{{count}} elementos necesitan atención.",
conditionsWatchClause_many: " {{count}} más para vigilar.",
watchlist_many: "Nada requiere su atención en este momento. {{count}} cosas para vigilar.{{motion}}",
inMotionOnly_many: "Nada requiere su atención en este momento. {{count}} elementos están planificados o en curso.",
inMotionClause_many: " {{count}} elementos están planificados o en curso.",
},
},
copilot: {
overdue: {
title: "Trabajo atrasado",
body_one: "{{count}} trabajo abierto con fecha de vencimiento pasada. Priorice programarlo o cerrarlo.",
body_other: "{{count}} trabajos abiertos con fecha de vencimiento pasada. Priorice programarlos o cerrarlos.",
action: "Abrir trabajos",
body_many: "{{count}} trabajos abiertos con fecha de vencimiento pasada. Priorice programarlos o cerrarlos.",
},
failedFindings: {
title: "Hallazgos de inspección",
body_one: "{{count}} inspección completada en este ámbito incluye elementos no superados. Convierta los hallazgos críticos en trabajos cuando esté listo.",
body_other: "{{count}} inspecciones completadas en este ámbito incluyen elementos no superados. Convierta los hallazgos críticos en trabajos cuando esté listo.",
action: "Inspecciones",
body_many: "{{count}} inspecciones completadas en este ámbito incluyen elementos no superados. Convierta los hallazgos críticos en trabajos cuando esté listo.",
},
throughput: {
title: "Ritmo de cierre",
bodyUp: "Los cierres verificados aceleraron en la segunda mitad de los últimos {{days}} días.",
bodyDown: "Los cierres verificados se ralentizaron en la segunda mitad de los últimos {{days}} días. Revisa bloqueos.",
action: "Cola de trabajo",
},
unassigned: {
title: "Cobertura de asignación",
body_one: "{{count}} trabajo abierto no tiene responsable. Asigne responsables para mejorar la rendición de cuentas.",
body_other: "{{count}} trabajos abiertos no tienen responsable. Asigne responsables para mejorar la rendición de cuentas.",
action: "Trabajos",
body_many: "{{count}} trabajos abiertos no tienen responsable. Asigne responsables para mejorar la rendición de cuentas.",
},
assetHealth: {
title: "Activos bajo estrés",
body_one: "{{count}} activo en este ámbito está en la franja de salud deficiente (trabajo abierto, hallazgos o antigüedad).",
body_other: "{{count}} activos en este ámbito están en la franja de salud deficiente (trabajo abierto, hallazgos o antigüedad).",
action: "Activos",
body_many: "{{count}} activos en este ámbito están en la franja de salud deficiente (trabajo abierto, hallazgos o antigüedad).",
},
allClear: {
title: "Instantánea operativa",
body: "Sin señales urgentes de Copilot en este ámbito en los últimos {{days}} días. Revisa gráficos y mantén asignaciones.",
},
},
copilotCards: {
  sync: {
    body_many: "{{count}} cambios guardados en este dispositivo esperan para enviarse.",
    primary: "Ver cambios sin enviar",
    body_other: "{{count}} cambios guardados en este dispositivo esperan para enviarse.",
    body_one: "1 cambio guardado en este dispositivo espera para enviarse.",
    title: "Cambios sin enviar",
  },
  requests: {
    title_many: "{{count}} solicitudes urgentes que revisar",
    primary: "Revisar solicitudes",
    body: "Abre las solicitudes para ver su urgencia y convertirlas en trabajo.",
    title_other: "{{count}} solicitudes urgentes que revisar",
    title_one: "1 solicitud urgente que revisar",
  },
  brief: {
    draft: "Redacta el plan de hoy para {{overdue}} elementos vencidos y {{today}} para hoy. Pon primero lo urgente y sé breve.",
    primary: "Proponer un plan",
    body: "{{overdue}} vencidos y {{today}} para hoy. El asistente puede ordenarlos.",
    title: "Planificar el trabajo de hoy",
  },
},
syncBanner: {
pending_one: "Sincronización pendiente: {{count}} cambio sin conexión en espera de reintento.",
pending_many: "Sincronización pendiente: {{count}} de cambios sin conexión en espera de reintento.",
pending_other: "Sincronización pendiente: {{count}} cambios sin conexión en espera de reintento.",
},
healthEntries: {
ok: "Correcto",
syncLabel: "Sincronización",
syncPending_one: "{{count}} pendiente",
syncPending_many: "{{count}} pendientes",
syncPending_other: "{{count}} pendientes",
syncUpToDate: "Al día",
failedSyncsLabel: "Sincronizaciones fallidas",
failedSyncsCount_one: "{{count}} fallida",
failedSyncsCount_many: "{{count}} fallidas",
failedSyncsCount_other: "{{count}} fallidas",
iotLabel: "IoT",
iotCount_one: "{{count}} aviso",
iotCount_many: "{{count}} de avisos",
iotCount_other: "{{count}} avisos",
iotTitle: "Avisos de IoT",
iotEmpty: "No hay avisos de IoT.",
},
};
